import { GetAssetsByAssetIdApiResponse } from "infra/api/generated/api";

import { Center, Flex } from "@chakra-ui/react";

interface AssetZoomVideoViewerProps {
  asset: GetAssetsByAssetIdApiResponse["asset"];
}

export default function AssetZoomVideoViewer({
  asset,
}: AssetZoomVideoViewerProps) {
  return (
    <Flex pos="relative" flex={1} w="100%" bgColor="black">
      <Center pos="absolute" top={0} right={0} bottom={0} left={0}>
        <video
          src={asset.url}
          autoPlay
          loop
          style={{ width: "80%", height: "80%" }}
          controls
        />
      </Center>
    </Flex>
  );
}
